module.exports = __webpack_public_path__ + "2dc874a67bb9b56cf25e40012506960a.fbx";